export default __webpack_public_path__ + "static/media/spiderman2.9a086fd0.mp4";